import React, {useCallback} from "react";
import PropTypes from "prop-types";
import {InformationCircleIcon} from "@heroicons/react/outline";

import DocumentBodyEditableFormattedNumberInput from "./document-body-editable-number-input";

const DocumentBodyPurchasePriceCell = ({
    value,
    symbol,
    t,
    isEditable,
    onCommit,
    onOpenHistory,
    canViewHistory,
}) => {
    const suffix = symbol ? ` ${symbol}` : "";

    const handleOpenHistory = useCallback(() => {
        if (!canViewHistory || typeof onOpenHistory !== "function") {
            return;
        }
        onOpenHistory();
    }, [canViewHistory, onOpenHistory]);


    return (
        <div className="flex w-full items-center gap-2">
            <div className="flex-none">
                {
                    canViewHistory && (
                        <button
                            type="button"
                            onClick={handleOpenHistory}
                            className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-transparent text-blue-600 transition hover:bg-blue-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-50"
                            title={t("app.quotations.purchase_history", {defaultValue: "Storico acquisti"})}
                            aria-label={t("app.quotations.purchase_history", {defaultValue: "Storico acquisti"})}
                        >
                            <InformationCircleIcon className="h-4 w-4" aria-hidden="true" />
                        </button>
                    )
                }

            </div>
            <div className="flex-1 text-right">
                <DocumentBodyEditableFormattedNumberInput
                    value={value ?? ""}
                    onCommit={onCommit}
                    suffix={suffix}
                    decimalScale={4}
                    isEditable={isEditable}
                    className="text-right"
                />
            </div>
        </div>
    );
};

DocumentBodyPurchasePriceCell.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    symbol: PropTypes.string,
    t: PropTypes.func.isRequired,
    isEditable: PropTypes.bool,
    onCommit: PropTypes.func,
    onOpenHistory: PropTypes.func,
    canViewHistory: PropTypes.bool,
};

DocumentBodyPurchasePriceCell.defaultProps = {
    value: "",
    symbol: "",
    isEditable: true,
    onCommit: undefined,
    onOpenHistory: undefined,
    canViewHistory: true,
};

export default DocumentBodyPurchasePriceCell;
